import React, { useState, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { useData } from '../context/DataContext';
import { useLoading } from '../hooks/useLoading';
import { Topbar } from '../components/Topbar';
import { Calendar, MapPin, Clock, Users, Search, XCircle, TrendingUp, Info } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Card, Button, Badge, SearchInput, Skeleton } from '../components/ui';

export function MyClassesPage() {
  const { user } = useAuth();
  const { classes } = useData();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedClass, setSelectedClass] = useState(null);
  const loading = useLoading(500);

  const myClasses = useMemo(() => {
    return classes
      .filter(c => user.type === 'professor' ? c.professor === 'Corpo Docente' : true)
      .filter(c => c.name.toLowerCase().includes(searchTerm.toLowerCase()));
  }, [classes, user.type, searchTerm]);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Topbar />
      
      <div className="flex flex-col items-center justify-center py-20 text-center bg-[#0b1322] border border-[#1d2a42] rounded-[32px] mt-6">
        <div className="w-20 h-20 bg-purple/10 rounded-full flex items-center justify-center mb-6">
          <Calendar size={40} className="text-purple" />
        </div>
        <h2 className="text-2xl font-bold mb-2">Minhas Aulas</h2>
        <p className="text-muted max-w-md mx-auto">
          Suas aulas e turmas aparecerão aqui após a confirmação da sua matrícula institucional.
        </p>
        <Button className="mt-8" onClick={() => window.location.href = '/cursos'}>Escolher Curso</Button>
      </div>
    </motion.div>
  );
}
